import types from 'constants/SessionConstants';
import axios from 'axios';
import {getURL} from '../routes';

export function fetchSessionSetting() {
  return axios.get(getURL('/api/shift'))
}

export function updateSessionSetting(data) {
  return axios.put(getURL('/api/shift'), data)
}

/*
function parseSessionData(data) {
  for (let key in data) {
    let val = data[key];
    if (typeof val === 'string' && val.includes(':')){
      let [hours, mins] = val.split(":");
      data[key] = +hours * 60 + +mins;
    }
  }
}
*/

export function prepareRefreshSessionSetting(data) {
  return (dispatch) => {
    let {mornShift, aftnShift, OTConfig} = data;
    dispatch(refreshSessionSetting([mornShift, aftnShift, OTConfig]));
  }
}

export function refreshSessionSetting(sessionConfig) {
  return {
    type: types.REFRESH_SESSION,
    sessionConfig
  }
}



// WEBPACK FOOTER //
// ./src/actions/SessionActions.js